import React from "react";
import PropTypes from "prop-types";

const workflowAppVersion = require("../../version");

class VersionInfo extends React.Component {
    render() {
        let state = this.props.store.getState();

        if (state.questionSet && state.questionSet.questionSet && state.workflowSession
            && (state.workflowSession.currentQuestionId === state.questionSet.questionSet.questions[0].questionID ||
                state.workflowSession.currentQuestionId === ""))
        {
            return (
                <div className="w3-small">
                    {workflowAppVersion.version} {workflowAppVersion.buildNumber}
                </div>
            );
        }

        return null;
    }
}

VersionInfo.contextTypes = {
    store: PropTypes.object
};

export default VersionInfo;
